import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type PillTone = 'amber' | 'moss' | 'sage' | 'soil' | 'petal' | 'mute';

const styles: Record<PillTone, string> = {
  amber: 'text-amber-500 border-[rgba(192,138,62,0.4)] bg-[rgba(192,138,62,0.08)]',
  moss: 'text-moss-300 border-[rgba(149,184,134,0.4)] bg-[rgba(149,184,134,0.08)]',
  sage: 'text-sage-300 border-[rgba(126,154,130,0.4)] bg-[rgba(126,154,130,0.08)]',
  soil: 'text-soil-300 border-[rgba(184,154,115,0.4)] bg-[rgba(184,154,115,0.06)]',
  petal: 'text-petal-300 border-[rgba(185,111,108,0.4)] bg-[rgba(185,111,108,0.08)]',
  mute: 'text-fg-3 border-[var(--border)] bg-transparent',
};

interface Props {
  tone?: PillTone;
  dot?: boolean;
  children: ReactNode;
  className?: string;
}

export function Pill({ tone = 'mute', dot = true, children, className }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-[7px] font-body font-semibold text-[11px] uppercase tracking-[0.08em] px-[11px] py-[5px] rounded-pill border',
        styles[tone],
        className,
      )}
    >
      {dot && (
        <span
          className="w-[6px] h-[6px] rounded-full bg-current"
          style={{ boxShadow: '0 0 0 3px rgba(255,255,255,0.04)' }}
        />
      )}
      {children}
    </span>
  );
}

export default Pill;
